






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import _ from 'lodash'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import ChatSolicitacaoComentarioStore from '@/components/chat-solicitacao-comentario/store/chat-solicitacao-comentario-store'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import ContestacaoMedicaStore from '@/components/ContestacaoMedica/Store/ContestacaoMedicaStore'
import { backofficeRoute, humanTime, displayColorBySituation, displayColorByStatus, verifyEtapaAutorizacao, timeoutDefault, groupCollectionByField, maskHour, maskDate, lembreteColor, displayRoboAutorizacao, getHospitalAreaName, displayCategoriaDoPlanoParaFidelizacao, syncWhatsAppFlagFromPost } from '@/utils/common'
import { StatusSlaEnum, IRequestMessage, RequestMessage, Loading, LembreteEnum, AgendamentoCirurgia, SituacaoEnum, TipoDocumentoUpload, PendenciaMensagem, TipoMensagemEnum, AgendamentoSolicitacaoItem, Solicitacao, User } from '@/types/_'
import { Acoes } from '@/types/interfaces/Solicitacao'
import { Autorizacao, PendenciaSolicitacao } from '@/types/core'
import EventBus from '@/plugins/EventBus'
import { IAgrupadorHospital } from '@/types/interfaces/agrupador-hospital'
import AgendamentoBackofficeApi from '@/Apis/Agendamento/Services/AgendamentoBackofficeApi'
import CadastroApi from '@/Apis/Cadastro/Services/CadastroApi'
import BackofficeRegulacaoStore from '@/components/Backoffice/Store/BackofficeRegulacaoStore'
import { AceiteMedicoAutorizacaoParcialMixin } from '@/mixins/solicitacao'
import BackofficeModalChatStore from './backoffice-chat/store/backoffice-modal-chat-store'
import useRenovacaoAutorizacao from '@/composables/useRenovacaoAutorizacao/useRenovacaoAutorizacao'

@Component({ filters: { humanTime } })
export default class ViewBackofficeAutorizacaoBase extends mixins(AceiteMedicoAutorizacaoParcialMixin) {
  @Prop({ default: [] }) etapasDefault: any[]
  @Prop({ default: [] }) etapasAdicionais: any[]
  @Prop({ default: 'Autorizacao' }) area: string
  @Prop({ default: ['analisePreAutorizacao', 'analisePreCotacao'] }) situacoesIniciais: string[]

  @Prop({ default: [] }) selectedFidelizationStatus: string[]
  @Prop({ default: [] }) fidelizationStatuses: string[]

  @Prop({ default: true }) canShowFilterByStatus: boolean
  @Prop({ default: true }) canShowAdvancedFilters: boolean
  @Prop({ default: false }) canShowFilterByProtocolo: boolean
  @Prop({ default: false }) canShowFilterByProtocoloProductLine: boolean

  $refs: {
    chatScrollContent: HTMLElement,
    cirurgiaDe: any,
  }

  hTime(s: string) {
    return humanTime(s)
  }

  displayDataAgendamento(item: any) {
    if (item.situacao.key === 'Cancelada') return 'Sem previsão'
    if (item.situacaoData.key === 'NovaDataSolicitada') return 'Nova data solicitada'
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    if (item.dataAgendamentoVirtual) return 'Data virtual'
    if (item.dataAgendamento) return this.hTime(item.dataAgendamento)
    if (item.opcaoDataPrevisto1) return this.hTime(item.opcaoDataPrevisto1)
    return 'Sem previsão'
  }

  formatDataAgendamento(item: any) {
    if (item.situacao.key === 'Cancelada') return 'bold__text--grey'
    if (item.situacaoData.key === 'NovaDataSolicitada') return 'bold__text--orange'
    if (item.situacaoData.key === 'SemData') return 'bold__text--light-grey'
    if (item.dataAgendamentoVirtual) return 'bold__text--yellow'
    if (item.dataAgendamento) return 'bold__text--grey'
    if (item.opcaoDataPrevisto1) return 'bold__text--red'
    return 'bold__text--grey'
  }

  $user: User;

  columnSelectionMenu: boolean = false
  loadVisualizar: string = ''
  loadAutorizada: string = ''
  loadIniciarProcesso: string = ''
  loadAutorizarProcesso: string = ''
  loadAguardandoNegociacaoParticular: string = ''
  loadRetornoDaAutorizacaoDoHis: string = ''
  loadRealizarRevisaoCirurgicaAutorizacao: string = ''
  loadRespondePendencia: string = ''
  loadResolverContestacao: string = ''
  loadEmCotacaoSolicitacao: string = ''
  loadHistorico: string = ''
  loadComentario: string = ''
  loadingAnalisarProtocolo: string = ''

  loadUpload: boolean = false
  loadMensagem: boolean = false
  modalPendencia: boolean = false
  loadClosePedencia: boolean = false
  loadEncerrarPendencia: boolean = false
  loadConfirmarEncerrarPendencia: boolean = false
  modalConfirmarEncerrarPendencia: boolean = false
  loadCloseConfiramrEncerrarPendencia: boolean = false
  mensagem: string = ''
  modalRoboAutorizacao: boolean = false
  roboAutorizacaoMotivoNegativa: string = ''
  statusRobo: string = ''
  statusIntegracaoOperadora: boolean = false
  inputFiles: any[] = []

  expand: boolean = false

  @Prop({ default: [] }) headers: any[]

  autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()
  pendenciaSolicitacao: PendenciaSolicitacao.IPendenciaSolicitacao = new PendenciaSolicitacao.PendenciaSolicitacao()

  get loadingRenovarAutorizacaoOperadora() {
    return useRenovacaoAutorizacao.loadingRenovar
  }

  showModalRenovarAutorizacao: boolean = false
  agendamentoParaRenovar: AgendamentoSolicitacaoItem | null = null

  getRequestMessage: IRequestMessage = new RequestMessage()
  areaDoHospital: any = getHospitalAreaName()

  loadingReq: Loading = {
    status: false,
    text: '',
  }

  displayPendencia: any = {
    nomePaciente: '',
    nomeMedico: '',
  }

  segueOProtocoloFilter: string[] = []
  protocoloFilterOptions = [
    { key: 'SegueOProtocolo', display: 'Segue o Protocolo' },
    { key: 'NaoSegueOProtocolo', display: 'Não Segue o Protocolo' },
  ]

  protocoloOperadoraTimeout: any
  protocoloOperadora = ''

  regionalFilterOptions: IAgrupadorHospital[] = []
  especialidadeFilterOptions: { id: string, descricao: string }[] = []

  hasHeaderColumn(name: string) {
    return !!this.headers.find(elem => elem.value === name)
      && this.headers.find(elem => elem.value === name).active
  }

  modDe: boolean = false

  get de() {
    return this.getBackofficeAutorizacaoStore.deFiltro
  }

  set de(value: Date | string | null) {
    this.getBackofficeAutorizacaoStore.setDeFiltro(value)
  }

  get formattedDe() {
    return this.formatDateRange(this.de)
  }

  get modalDe() {
    return this.modDe
  }

  set modalDe(value: boolean) {
    this.modDe = value
  }

  formatDateRange(date: Date | string | null) {
    if (!date) return null
    const [year, month, day] = date.toString().split('-')
    return `${day}/${month}/${year}`
  }

  resetModalDe() {
    this.de = null
    this.modalDe = false
  }

  minDate(date: string) {
    if (!date) return null
    const min = moment(date).add(1, 'day').format('YYYY-MM-DD')
    return min
  }

  maxDate(date: string) {
    if (!date) return null
    const max = moment(date).add(1, 'year').format('YYYY-MM-DD')
    return max
  }

  clearDate(field: string) {
    if (field === 'de') {
      this.de = null
    }
  }

  get loadingComentario() {
    return this.loadComentario
  }

  set loadingComentario(value: string) {
    this.loadComentario = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: string) {
    this.loadHistorico = value
  }

  get loadingEmCotacaoSolicitacao() {
    return this.loadEmCotacaoSolicitacao
  }

  set loadingEmCotacaoSolicitacao(value: string) {
    this.loadEmCotacaoSolicitacao = value
  }

  get loadingCloseConfirmarEncerrarPendencia() {
    return this.loadCloseConfiramrEncerrarPendencia
  }

  set loadingCloseConfirmarEncerrarPendencia(value: boolean) {
    this.loadCloseConfiramrEncerrarPendencia = value
  }

  get loadingConfirmarEncerrarPendencia() {
    return this.loadConfirmarEncerrarPendencia
  }

  set loadingConfirmarEncerrarPendencia(value: boolean) {
    this.loadConfirmarEncerrarPendencia = value
  }

  get showModalConfirmarEncerrarPendencia() {
    return this.modalConfirmarEncerrarPendencia
  }

  set showModalConfirmarEncerrarPendencia(value: boolean) {
    this.modalConfirmarEncerrarPendencia = value
  }

  get loadingEncerrarPendencia() {
    return this.loadEncerrarPendencia
  }

  set loadingEncerrarPendencia(value: boolean) {
    this.loadEncerrarPendencia = value
  }

  get loadingResolverContestacao() {
    return this.loadResolverContestacao
  }

  set loadingResolverContestacao(value: string) {
    this.loadResolverContestacao = value
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get loadingRespondePendencia() {
    return this.loadRespondePendencia
  }

  set loadingRespondePendencia(value: string) {
    this.loadRespondePendencia = value
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getDisplayPendencia() {
    return this.displayPendencia
  }

  set getDisplayPendencia(value: any) {
    this.displayPendencia = value
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get loadingAutorizarProcesso() {
    return this.loadAutorizarProcesso
  }

  set loadingAutorizarProcesso(val: string) {
    this.loadAutorizarProcesso = val
  }

  get loadingAguardandoNegociacaoParticular() {
    return this.loadAguardandoNegociacaoParticular
  }

  set loadingAguardandoNegociacaoParticular(val: string) {
    this.loadAguardandoNegociacaoParticular = val
  }

  get loadingRetornoDaAutorizacaoDoHis() {
    return this.loadRetornoDaAutorizacaoDoHis
  }

  set loadingRetornoDaAutorizacaoDoHis(value: string) {
    this.loadRetornoDaAutorizacaoDoHis = value
  }

  get loadingRealizarRevisaoCirurgicaAutorizacao() {
    return this.loadRealizarRevisaoCirurgicaAutorizacao
  }

  set loadingRealizarRevisaoCirurgicaAutorizacao(val: string) {
    this.loadRealizarRevisaoCirurgicaAutorizacao = val
  }

  get loadingAutorizada() {
    return this.loadAutorizada
  }

  set loadingAutorizada(val: string) {
    this.loadAutorizada = val
  }

  get loadingVisualizar() {
    return this.loadVisualizar
  }

  set loadingVisualizar(val: string) {
    this.loadVisualizar = val
  }

  get loadingIniciarProcesso() {
    return this.loadIniciarProcesso
  }

  set loadingIniciarProcesso(value: string) {
    this.loadIniciarProcesso = value
  }

  get loadingRequest() {
    return this.loadingReq
  }

  set loadingRequest(value: Loading) {
    this.loadingReq = value
  }

  get displayCategoriaDoPlanoParaFidelizacao() {
    return displayCategoriaDoPlanoParaFidelizacao
  }

  scrollToMensagem() {
    if (this.$refs.chatScrollContent) {
      setTimeout(() => {
        const elem = this.$refs.chatScrollContent

        const option: ScrollToOptions = {
          behavior: 'smooth',
          left: 0,
          top: elem.scrollHeight,
        }
        elem.scrollTo(option)
      }, 0)
    }
  }

  @Watch('showModalPendencia')
  onChangeShowModalPendencia() {
    this.scrollToMensagem()
  }

  formatStatus(status: string) {
    return displayRoboAutorizacao(status)
  }

  openModalRoboAutorizacao(item: any) {
    this.modalRoboAutorizacao = true
    this.roboAutorizacaoMotivoNegativa = item.roboAutorizacaoMotivoNegativa
    this.statusRobo = item.statusRobo.display
    this.statusIntegracaoOperadora = item.hospitalEConvenioUtilizamRoboDeAutorizacao
  }

  closeModalRoboAutorizacao() {
    this.modalRoboAutorizacao = false
    this.roboAutorizacaoMotivoNegativa = ''
    this.statusRobo = ''
    this.statusIntegracaoOperadora = false
  }

  robotColor(value: boolean = false, item: any) {
    if (!value || !item.statusRobo) return { color: '#CFD8DC' }
    return displayRoboAutorizacao(item.statusRobo.key.toUpperCase())
  }

  robotLabelStatus(value: boolean = false, item: any) {
    if (!value || !item.statusRobo) return { text: 'Robô inativo' }
    return displayRoboAutorizacao(item.statusRobo.key.toUpperCase())
  }

  async init() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getBackofficeAutorizacaoStore.clearSituacoes()
    this.getBackofficeAutorizacaoStore.clearSolicitacoes()
    this.getBackofficeAutorizacaoStore.clearFiltro()
    this.getBackofficeAutorizacaoStore.setFilterOn(false)
    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')

    // eslint-disable-next-line no-restricted-syntax
    for (const elem of this.situacoesIniciais) {
      this.getBackofficeAutorizacaoStore.setSituacoes(elem)
    }

    this.getBackofficeAutorizacaoStore.setEtapa(this.area)
    this.getBackofficeAutorizacaoStore.setFidelizationStatusFilter(this.selectedFidelizationStatus)
    await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch()

    const regionalRes = await AgendamentoBackofficeApi.getAllAgrupadorHospitaByUsuario('Regional')
    if (regionalRes.success) {
      this.regionalFilterOptions = regionalRes.data!
    }

    const especialidadeRes = await CadastroApi.getCbosAll()
    if (especialidadeRes.success) {
      this.especialidadeFilterOptions = especialidadeRes.data!
    }

    this.clearLoadingRequest()
  }

  displayReserva(item: any) {
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    return item.numeroAgendamento || 'Sem reserva'
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest = { status, text }
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }


  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get solicitacoes() {
    return this.getBackofficeAutorizacaoStore.solicitacoes
  }

  get drawer() {
    return this.getBackofficeAutorizacaoStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getBackofficeAutorizacaoStore.setFilterDrawer(value)
  }

  async fidelizationStatusFilterChange(item: { key: string, value: string }) {
    const index = this.selectedFidelizationStatus.findIndex(elem => elem === item.key)
    if (index === -1) {
      this.selectedFidelizationStatus.push(item.key)
    } else {
      this.selectedFidelizationStatus.splice(index, 1)
    }
    this.getBackofficeAutorizacaoStore.setFidelizationStatusFilter(this.selectedFidelizationStatus)
    this.filterSituacao()
  }

  segueOProtocoloFilterChange() {
    this.getBackofficeAutorizacaoStore.setSegueOProtocoloFilter(this.segueOProtocoloFilter)
    this.filterSituacao()
  }

  protocoloOperadoraChange() {
    // eslint-disable-next-line prefer-destructuring
    const protocoloOperadora = this.protocoloOperadora

    // eslint-disable-next-line eqeqeq
    if (this.protocoloOperadoraTimeout != undefined) {
      clearTimeout(this.protocoloOperadoraTimeout)
      this.protocoloOperadoraTimeout = null
    }

    this.protocoloOperadoraTimeout = setTimeout(() => {
      this.getBackofficeAutorizacaoStore.setProtocoloOperadoraFilter(protocoloOperadora)
      this.protocoloOperadoraTimeout = null
      this.filterSituacao()
    }, 800)
  }

  get categoriaDoPlanoParaFidelizacaoFilter() {
    return this.getBackofficeAutorizacaoStore.categoriaDoPlanoParaFidelizacao
  }

  set categoriaDoPlanoParaFidelizacaoFilter(value: any[]) {
    this.getBackofficeAutorizacaoStore.setCategoriaDoPlanoParaFidelizacao(value)
  }

  get categoriaDoPlanoParaFidelizacaoFilterOptions() {
    return [
      { key: 'community', display: 'Community' },
      { key: 'indefinido', display: 'Indefinido' },
      { key: 'outros', display: 'Outros' },
    ]
  }

  async categoriaDoPlanoParaFidelizacaoChange() {
    await this.$nextTick(() => {
      this.filterSituacao()
    })
  }

  get regionalFilter() {
    return this.getBackofficeAutorizacaoStore.agrupadorHospital
  }

  set regionalFilter(value: any[]) {
    this.getBackofficeAutorizacaoStore.setAgrupadorHospitaisIds(value)
  }

  async regionalFilterChange() {
    await this.$nextTick(() => {
      this.filterSituacao()
    })
  }

  get especialidadeFilter() {
    return this.getBackofficeAutorizacaoStore.protocolosEspecialidade
  }

  set especialidadeFilter(value: any[]) {
    this.getBackofficeAutorizacaoStore.setProtocolosEspecialidadeIds(value)
  }

  async especialidadeFilterChange() {
    await this.$nextTick(() => {
      this.filterSituacao()
    })
  }

  get etapa() {
    return this.getBackofficeAutorizacaoStore.situacoes
  }

  set etapa(value: any) {
    this.getBackofficeAutorizacaoStore.setSituacoes(value.key)
  }

  get etapas() {
    if (this.etapasDefault && this.etapasDefault.length > 0) {
      return [
        ...this.etapasDefault,
        ...this.etapasAdicionais,
      ]
    }

    return [
      ...this.etapasBase,
      ...this.etapasAdicionais,
    ]
  }

  get etapasBase() {
    const baseStatus = [
      { key: 'analisePreAutorizacao', display: 'Análise pré-autorização', quantidade: this.getAnalisePreAutorizacaoTotal },
      { key: 'analisePreCotacao', display: 'Análise pré-cotação', quantidade: this.getAnalisePreCotacaoTotal },
      { key: 'revisaoCirurgicaAutorizacao', display: 'Revisão cirúrgica', quantidade: this.getRevisaoCirurgicaAutorizacaoTotal },
      { key: 'aguardandoSuprimentos', display: 'Aguardando suprimentos', quantidade: this.getAguardandoSuprimentosTotal },
      { key: 'emCotacao', display: 'Aguardando cotação', quantidade: this.getEmCotacaoTotal },
      { key: 'incompleta', display: 'Em edição', quantidade: this.getEmEdicaoTotal },
      { key: 'pendente', display: 'Pendência médica', quantidade: this.getPendenteTotal },
      { key: 'pendenteDeEnvioRoboDeAutorizacao', display: 'Pendente de Autorização', quantidade: this.getPendenteDeEnvioRoboDeAutorizacaoTotal },
      { key: 'pendenciaRespondida', display: 'Pendência respondida', quantidade: this.getPendenciaRespondidaTotal },
      { key: 'analisePosCotacao', display: 'Análise pós-cotação', quantidade: this.getAnalisePosCotacaoTotal },
      { key: 'aguardandoOperadora', display: 'Aguardando autorização', quantidade: this.getAguardandoOperadoraTotal },
      { key: 'aguardandoNegociacaoParticular', display: 'Aguardando Negociação Particular', quantidade: this.getAguardandoNegociacaoParticularTotal },
      { key: 'respostaDoRoboDeAutorizacao', display: 'Retorno da Operadora (Robô)', quantidade: this.getRespostaDoRoboDeAutorizacaoTotal },
      { key: 'retornoDaAutorizacaoDoHis', display: 'Retorno da Operadora (His)', quantidade: this.getRetornoDaAutorizacaoDoHisTotal },
      { key: 'pendenteDeEnvioRoboDeAutorizacao', display: 'Resposta Operadora', quantidade: this.getPendenteDeEnvioRoboDeAutorizacaoTotal },
      { key: 'autorizadaParcial', display: 'Autorizada parcial', quantidade: this.getAutorizadaParcialTotal },
      // { key: 'autorizadaAceitaMedico', display: 'Autorizada - Aceite Médico', quantidade: this.getAutorizadaAceitaMedicoTotal },
      { key: 'autorizacaoPos', display: 'Autorização Pós', quantidade: this.getAutorizacaoPosTotal },
      { key: 'autorizada', display: 'Autorizada', quantidade: this.getAutorizadaTotal },
      { key: 'contestacaoMedica', display: 'Contestação Médica', quantidade: this.getContestacaoTotal },
      { key: 'contestacaoPendente', display: 'Contestação Pendente', quantidade: this.getContestacaoPendenteTotal },
      { key: 'aguardandoIntegracaoOperadora', display: 'Aguardando Integração Operadora', quantidade: this.getAguardandoIntegracaoOperadoraTotal },
      { key: 'erroIntegracaoOperadora', display: 'Erro de Integração Operadora', quantidade: this.getErroIntegracaoOperadoraTotal },
      { key: 'criticaOperadora', display: 'Crítica Operadora', quantidade: this.getCriticaOperadoraTotal },

    ]

    const hospitalHasUrgencyFlowAnalysis = this.getBackofficeAutorizacaoStore.hospitais.some(hospital => hospital.utilizaAnalisePreAutorizacaoUrgencia)
    const hospitalHasUrgencyFlowAnalysisWaiting = this.getBackofficeAutorizacaoStore.hospitais.some(hospital => hospital.utilizaAguardandoAutorizacaoUrgencia)

    if (hospitalHasUrgencyFlowAnalysisWaiting) {
      baseStatus.push({ key: 'AguardandoAutorizacaoUrgencia', display: 'Aguardando autorização urgência', quantidade: this.getAguardandoAutorizacaoUrgenciaTotal })
    }

    if (hospitalHasUrgencyFlowAnalysis) {
      baseStatus.push({ key: 'AnalisePreAutorizacaoUrgencia', display: 'Análise pré-autorização urgência', quantidade: this.getAnalisePreAutorizacaoUrgenciaTotal })
    }

    return baseStatus
  }

  get getAllEtapas() {
    return this.etapa.length === this.etapas.length
  }

  get getSomeEtapas() {
    return this.etapa.length > 0 && !this.getAllEtapas
  }

  get etapasFidelizacao() {
    return [
      { key: 'ProtocoloAderente', display: 'Protocolo aderente' },
      { key: 'ProtocoloNaoAderente', display: 'Protocolo não aderente' },
      { key: 'FidelizacaoAceitouJustificativa', display: 'Fidelização aceitou justificativa' },
      { key: 'PendenciaDeProtocolo', display: 'Pendência de protocolo' },
      { key: 'ProtocoloAceito', display: 'Protocolo aceito' },
      { key: 'ProtocoloRecusado', display: 'Protocolo recusado' },
      { key: 'EncaminhadoPelaRegulacao', display: 'Encaminhado pela regulação' },
      { key: 'PendenciaDeProtocoloExpirada', display: 'Pendência de protocolo expirada' },
    ]
  }

  get icon() {
    if (this.getAllEtapas) return 'mdi-checkbox-marked'
    if (this.getSomeEtapas) return 'mdi-minus-box'
    return 'mdi-checkbox-blank-outline'
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  formatDate(value: string) {
    return maskDate(value)
  }

  autorizacaoValidadeStatusClass(status?: string) {
    switch (status) {
      case 'ProximaDoVencimento':
        return 'autorizacao-validade--proxima'
      case 'Vencida':
        return 'autorizacao-validade--vencida'
      default:
        return ''
    }
  }

  renovarAutorizacaoOperadora(agendamento: AgendamentoSolicitacaoItem) {
    this.agendamentoParaRenovar = agendamento
    this.showModalRenovarAutorizacao = true
  }

  get todosOsStatus() {
    return this.getBackofficeAutorizacaoStore.todosOsStatus
  }

  set todosOsStatus(value: boolean) {
    this.getBackofficeAutorizacaoStore.setTodosOsStatus(value)
  }

  get todosOsStatusDaArea() {
    return this.getBackofficeAutorizacaoStore.todosOsStatusDaArea
  }

  set todosOsStatusDaArea(value: boolean) {
    this.getBackofficeAutorizacaoStore.setTodosOsStatusDaArea(value)
  }

  get iconTodosOsStatus() {
    return this.todosOsStatus ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  get iconTodosOsStatusDaArea() {
    return this.todosOsStatusDaArea ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  selectAllFromHospital() {
    this.$nextTick(() => {
      this.todosOsStatus = !this.todosOsStatus
    })
  }

  selectAllFromArea() {
    this.$nextTick(() => {
      this.todosOsStatusDaArea = !this.todosOsStatusDaArea
    })
  }

  selectSituacao(item: any) {
    if (this.todosOsStatus || this.todosOsStatusDaArea) {
      this.todosOsStatus = false
      this.todosOsStatusDaArea = false
      this.getBackofficeAutorizacaoStore.clearSituacoes()
    }
    this.etapa = item
  }

  async filterSituacao() {
    if (!this.de && this.areaDoHospital === 'autorização') {
      EventBus.$emit('setSnackbar', { show: true, text: 'Preencha o campo de Data de início do período', icon: 'warning', color: '#C62828' })
      return
    }
    this.getBackofficeAutorizacaoStore.clearPagePagination()
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  get getAguardandoSuprimentosTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.length > 0
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoSuprimentos).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoSuprimentos)[0].quantidade
    }
    return 0
  }

  get getAguardandoOperadoraTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.length > 0
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoOperadora).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoOperadora)[0].quantidade
    }
    return 0
  }

  get getAguardandoNegociacaoParticularTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.length > 0
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoNegociacaoParticular).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoNegociacaoParticular)[0].quantidade
    }
    return 0
  }

  get getRetornoDaAutorizacaoDoHisTotal() {
    let countRetornoAutorizacaoPlusRespostaDoRobo = 0

    if (this.getBackofficeAutorizacaoStore.situacoesCounter.length > 0 && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.RetornoDaAutorizacaoDoHis).length > 0) {
      countRetornoAutorizacaoPlusRespostaDoRobo += this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.RetornoDaAutorizacaoDoHis)[0].quantidade
    }

    return countRetornoAutorizacaoPlusRespostaDoRobo
  }

  get getRespostaDoRoboDeAutorizacaoTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.length > 0
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.RespostaDoRoboDeAutorizacao).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.RespostaDoRoboDeAutorizacao)[0].quantidade
    }
    return 0
  }

  get getAutorizadaParcialTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.length > 0
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AutorizadaParcial).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AutorizadaParcial)[0].quantidade
    }
    return 0
  }

  get getAutorizadaAceitaMedicoTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.length > 0
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AutorizadaAceitaMedico).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AutorizadaAceitaMedico)[0].quantidade
    }
    return 0
  }

  get getAutorizacaoPosTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.length > 0
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AutorizacaoPos).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AutorizacaoPos)[0].quantidade
    }
    return 0
  }

  get getPendenteTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.length > 0
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Pendente).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.Pendente)[0].quantidade
    }
    return 0
  }

  get getPendenciaRespondidaTotal() {
    if (this.getBackofficeAutorizacaoStore
      .situacoesCounter.some(c => c.key === SituacaoEnum.PendenciaRespondida)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenciaRespondida).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.PendenciaRespondida)[0].quantidade
    }
    return 0
  }

  get getEmCotacaoTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.EmCotacao)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.EmCotacao).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.EmCotacao)[0].quantidade
    }
    return 0
  }

  get getAnalisePreAutorizacaoTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.AnalisePreAutorizacao)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePreAutorizacao).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePreAutorizacao)[0].quantidade
    }
    return 0
  }

  get getAnalisePreAutorizacaoUrgenciaTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.AnalisePreAutorizacaoUrgencia)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePreAutorizacaoUrgencia).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePreAutorizacaoUrgencia)[0].quantidade
    }
    return 0
  }

  get getAguardandoAutorizacaoUrgenciaTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.AguardandoAutorizacaoUrgencia)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoAutorizacaoUrgencia).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoAutorizacaoUrgencia)[0].quantidade
    }
    return 0
  }

  get getAguardandoIntegracaoOperadoraTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.AguardandoIntegracaoOperadora)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoIntegracaoOperadora).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoIntegracaoOperadora)[0].quantidade
    }
    return 0
  }

  get getErroIntegracaoOperadoraTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.ErroIntegracaoOperadora)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.ErroIntegracaoOperadora).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.ErroIntegracaoOperadora)[0].quantidade
    }
    return 0
  }

  get getCriticaOperadoraTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.CriticaOperadora)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.CriticaOperadora).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.CriticaOperadora)[0].quantidade
    }
    return 0
  }

  get getAnalisePreCotacaoTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.AnalisePreCotacao)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePreCotacao).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePreCotacao)[0].quantidade
    }
    return 0
  }

  get getRevisaoCirurgicaAutorizacaoTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.RevisaoCirurgicaAutorizacao)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.RevisaoCirurgicaAutorizacao).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.RevisaoCirurgicaAutorizacao)[0].quantidade
    }
    return 0
  }

  get getAnalisePosCotacaoTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.AnalisePosCotacao)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePosCotacao).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePosCotacao)[0].quantidade
    }
    return 0
  }

  get getPendenteDeEnvioRoboDeAutorizacaoTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.PendenteDeEnvioRoboDeAutorizacao)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteDeEnvioRoboDeAutorizacao).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteDeEnvioRoboDeAutorizacao)[0].quantidade
    }
    return 0
  }

  get getAutorizadaTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.Autorizada)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Autorizada).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.Autorizada)[0].quantidade
    }
    return 0
  }

  get getContestacaoTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.ContestacaoMedica)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.ContestacaoMedica).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.ContestacaoMedica)[0].quantidade
    }
    return 0
  }

  get getContestacaoPendenteTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.ContestacaoPendente)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.ContestacaoPendente).length > 0) {
      return this.getBackofficeAutorizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.ContestacaoPendente)[0].quantidade
    }
    return 0
  }

  get getEmEdicaoTotal() {
    if (this.getBackofficeAutorizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.Incompleta)
      && this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Incompleta).length > 0) {
      return this.getBackofficeAutorizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Incompleta)[0].quantidade
    }
    return 0
  }

  get getTotal() {
    return this.getBackofficeAutorizacaoStore.totalSolicitacoes || 0
  }

  verifyEtapa(item: any) {
    return verifyEtapaAutorizacao(item)
  }

  showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  getColor(status: string) {
    switch (status) {
      case 'Apto':
        return { color: 'green darken-2', icon: 'thumb_up', tooltip: 'Paciente apto para cirurgia' }
      case 'AptoComAtencao':
        return { color: 'yellow darken-3', icon: 'thumb_up', tooltip: 'Verificar alterações feitas pelo anestesista' }
      case 'NaoApto':
        return { color: 'red darken-3', icon: 'thumb_down', tooltip: 'Paciente não está apto para cirurgia' }
      default:
        return { color: 'orange darken-4', icon: 'schedule', tooltip: 'Avaliação pré-anestésica pendente' }
    }
  }

  getTableRowClasses(data: AgendamentoSolicitacaoItem) {
    const classes: string[] = []

    if (data.jaPassouPorEsteStatus) {
      classes.push('backoffice-list-table-row__japassouporessestatus')
    }

    if (data.carater.key === 'Urgencia') {
      classes.push('backoffice-list-table-row__urgencia')
    }

    if (data.auditada && this.$user.profile.roles.includes('auditoria') && ['BackofficeAutorizacao', 'BackofficeAgendamento'].includes(this.$route.name!)) {
      classes.push('backoffice-list-table-row__auditada')
    }

    return classes
  }

  async clearAdvancedFilters() {
    this.getBackofficeAutorizacaoStore.clearFiltro()
    this.getBackofficeAutorizacaoStore.setFilterOn(false)
    this.drawer = false
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)

    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')
    this.clearLoadingRequest()
  }

  displayCorSituacao(value: string) {
    return displayColorBySituation(value)
  }

  displayCorEtapa(value: string) {
    return displayColorByStatus(value)
  }

  slaColor(statusSla: StatusSlaEnum) {
    switch (statusSla) {
      case StatusSlaEnum.Normal:
        return 'green'

      case StatusSlaEnum.Alerta:
        return 'yellow'

      case StatusSlaEnum.Critico:
        return 'red'

      default:
        return ''
    }
  }

  async showModalIniciarProcesso(agendamentoCirurgia: AgendamentoCirurgia) {
    await this.abrirModal(agendamentoCirurgia, 'iniciarProcesso', 'abrir-modal-iniciar-processo', 'loadingIniciarProcesso')
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = ''
  }

  /**
   * ========== COMENTÁRIO E LEMBRETE ==========
   */

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  get chatSolicitacaoComentarioStore() {
    return getModule(ChatSolicitacaoComentarioStore, this.$store)
  }

  surgerySolicitationHasIntegrationError(solicitacao: AgendamentoSolicitacaoItem) {
    const actions = solicitacao.acoes
    return actions.possuiComentariosCriticaIntegracaoOperadora || actions.possuiComentariosErrosIntegracaoOperadora || solicitacao.possuiComentarioDeErro
  }

  getBadgeWarningColor(solicitacao: AgendamentoSolicitacaoItem) {
    const actions = solicitacao.acoes

    if (actions.possuiComentariosCriticaIntegracaoOperadora) {
      return 'orange'
    }

    if (actions.possuiComentariosErrosIntegracaoOperadora || solicitacao.possuiComentarioDeErro) {
      return 'red'
    }

    return ''
  }

  showBackofficeChatCommentDetails(actions: Acoes) {
    const simplifiedCommentPermission = actions.utilizaExibicaoDeComentarioSimplificado

    return this.areaDoHospital === 'autorização' && !simplifiedCommentPermission
  }

  async abrirChatSolicitacaoComentario(surgerySolicitation: AgendamentoSolicitacaoItem) {
    this.loadingComentario = surgerySolicitation.id
    this.chatSolicitacaoComentarioStore.reset()

    await this.chatSolicitacaoComentarioStore.openChatModal(surgerySolicitation)

    this.ga('backoffice-autorizacao', 'abrir-chat-solicitacao-comentario')
    this.loadingComentario = ''
  }

  async showComentario(solicitacaoId: string) {
    this.loadingComentario = solicitacaoId
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentario = ''
  }

  async openChat(surgerySolicitationData) {
    const chatData = {
      solicitationId: surgerySolicitationData.id,
      chatArea: 'autorizacao',
      recipientName: surgerySolicitationData.medicoNome,
      senderId: this.$user.profile.sub,
      senderName: this.$user.profile.name,
    }

    this.backofficeModalChatStore.reset()
    await this.backofficeModalChatStore.openChatModal(chatData)

    this.ga('backoffice-chat', 'abrir-chat')
  }

  lembreteColorDisplay(lembrete: LembreteEnum) {
    return lembreteColor(lembrete)
  }

  /**
   * ========== PAGINAÇÃO ==========
   */

  get getPagina() {
    return this.getBackofficeAutorizacaoStore.pagina
  }

  set getPagina(value: number) {
    this.getBackofficeAutorizacaoStore.setPagina(value)
  }

  get getQtdPorPagina() {
    return this.getBackofficeAutorizacaoStore.qtdPorPagina
  }

  set getQtdPorPagina(value: number) {
    this.getBackofficeAutorizacaoStore.setQtdPorPagina(value)
  }

  get getTotalSolicitacoes() {
    return this.getBackofficeAutorizacaoStore.totalSolicitacoes
  }

  get agendamentoLength() {
    return Math.ceil(this.getTotalSolicitacoes / this.getQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults(pagina: number) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getPagina = pagina
    await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  async mounted() {
    EventBus.$on('setLembrete', value => this.getBackofficeAutorizacaoStore.setLembreteStatus(value))
  }

  /**
   * ============ MODAIS E BOTÕES ==============
   */
  get backofficeModalChatStore() {
    return getModule(BackofficeModalChatStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getContestacaoMedicaStore() {
    return getModule(ContestacaoMedicaStore, this.$store)
  }

  async showModalRevisaoCirurgicaAutorizacao(agendamentoCirurgia: AgendamentoCirurgia | Solicitacao) {
    this.getBackofficeGlobalStore.setSolicitationFromList(agendamentoCirurgia as Solicitacao)
    await this.abrirModal(agendamentoCirurgia as AgendamentoCirurgia, 'revisaoCirurgicaAutorizacao', '', 'loadingRealizarRevisaoCirurgicaAutorizacao')
  }

  async showModalVisualizar(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingVisualizar = agendamentoCirurgia.id

    this.getBackofficeGlobalStore.setBackofficeArea(backofficeRoute())
    this.getBackofficeGlobalStore.setSolicitacaoId(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })

    this.ga('backoffice-autorizacao', 'visualizar-autorizacao')
    this.loadingVisualizar = ''
  }

  async showModalAnalisarProtocolo(agendamentoCirurgia: AgendamentoCirurgia) {
    try {
      const surgerySolicitationId = agendamentoCirurgia.id
      this.loadingVisualizar = surgerySolicitationId

      const blockSurgerySolicitationAPIRequest = await this.backofficeRegulacaoStore.blockFidelizationSurgerySolicitation(surgerySolicitationId)

      if (blockSurgerySolicitationAPIRequest.success) {
        const response = await this.getBackofficeGlobalStore.getSolicitacaoById(surgerySolicitationId)

        if (response.success) {
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          const solicitacaoDoStore = this.getBackofficeAutorizacaoStore.solicitacoes.find((solicitacao: AgendamentoSolicitacaoItem) => solicitacao.id === surgerySolicitationId)
          if (solicitacaoDoStore) {
            syncWhatsAppFlagFromPost(response.data, solicitacaoDoStore)
            this.$store.commit('BackofficeGlobalStore/setSolicitacao', response.data)
          }
          this.getBackofficeGlobalStore.setModal({ name: 'regulacao', value: true })
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
        }
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: blockSurgerySolicitationAPIRequest.message || 'Solicitação já está em atendimento', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível concluir a operação', icon: 'warning', color: '#C62828' })
    } finally {
      this.ga('backoffice-autorizacao', 'analisar-protocolo')
      this.loadingVisualizar = ''
    }
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  conferirSolicitacao(agendamentoCirurgia: AgendamentoCirurgia) {
    this.showModalAutorizacao(agendamentoCirurgia)
    this.ga('backoffice-autorizacao', 'conferir-solicitacao')
  }

  async emCotacaoSolicitacao(agendamentoCirurgia: AgendamentoCirurgia) {
    await this.abrirModal(agendamentoCirurgia, 'atualizarAutorizacao', 'em-autorizacao', 'loadingEmCotacaoSolicitacao')
  }

  async autorizarProcesso(agendamentoCirurgia: AgendamentoCirurgia) {
    await this.abrirModal(agendamentoCirurgia, 'autorizarProcesso', 'autorizar-solicitacao', 'loadingAutorizarProcesso')
  }

  async showModalAguardandoNegociacaoParticular(agendamentoCirurgia: AgendamentoCirurgia) {
    await this.abrirModal(agendamentoCirurgia, 'aguardandoNegociacaoParticular', 'aguardando-negociacao-particular', 'loadingAguardandoNegociacaoParticular')
  }

  async showModalRetornoDaAutorizacaoDoHis(agendamentoCirurgia: AgendamentoCirurgia) {
    await this.abrirModal(agendamentoCirurgia, 'retornoDaAutorizacaoDoHis', 'autorizar-solicitacao', 'loadingRetornoDaAutorizacaoDoHis')
  }

  async autorizada(agendamentoCirurgia: AgendamentoCirurgia) {
    await this.abrirModal(agendamentoCirurgia, 'autorizarProcesso', 'autorizada', 'loadingAutorizada')
  }

  private async abrirModal(
    agendamentoCirurgia: AgendamentoCirurgia,
    modalName: string,
    gaEvent: string,
    loadingRef: keyof this,
  ): Promise<void> {
    const self = this as any
    const solicitacaoId = agendamentoCirurgia.id
    self[loadingRef] = solicitacaoId

    let response = await this.autorizacao.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      if (response.success) {
        await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
        const solicitacaoDoStore = this.getBackofficeAutorizacaoStore.solicitacoes.find((solicitacao: AgendamentoSolicitacaoItem) => solicitacao.id === solicitacaoId)
        if (solicitacaoDoStore) {
          syncWhatsAppFlagFromPost(response.data, solicitacaoDoStore)
          this.$store.commit('BackofficeGlobalStore/setSolicitacao', response.data)
        }
        this.getBackofficeGlobalStore.setModal({ name: modalName, value: true })
        if (gaEvent) this.ga('backoffice-autorizacao', gaEvent)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    self[loadingRef] = ''
  }

  async openFlowModal(agendamentoCirurgia: AgendamentoCirurgia | Solicitacao) {
    const response = await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoCirurgia.id)
    if (response.success) {
      const solicitacaoDoStore = this.getBackofficeAutorizacaoStore.solicitacoes.find((solicitacao: AgendamentoSolicitacaoItem) => solicitacao.id === agendamentoCirurgia.id)
      if (solicitacaoDoStore) {
        syncWhatsAppFlagFromPost(this.getBackofficeGlobalStore.solicitacao, solicitacaoDoStore)
      }

      switch (this.getBackofficeGlobalStore.solicitacao.situacao.key) {
        case 'AnalisePreAutorizacao':
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'iniciarProcesso', value: true })
          this.ga('backoffice-autorizacao', 'abrir-modal-iniciar-processo')
          break

        case 'AnalisePreCotacao':
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'iniciarProcesso', value: true })
          this.ga('backoffice-autorizacao', 'abrir-modal-iniciar-processo')
          break

        case 'Autorizacao':
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'autorizarProcesso', value: true })
          this.ga('backoffice-autorizacao', 'autorizar-solicitacao')
          break

        case 'EmCotacao':
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'atualizarAutorizacao', value: true })
          this.ga('backoffice-autorizacao', 'em-autorizacao')
          break

        case 'AguardandoOperadora':
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'autorizarProcesso', value: true })
          this.ga('backoffice-autorizacao', 'autorizar-solicitacao')
          break

        case 'AutorizadaParcial':
        case 'AutorizadaAceitaMedico':
        case 'AutorizacaoPos':
        case 'Autorizada':
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'autorizada', value: true })
          this.ga('backoffice-autorizacao', 'autorizada')
          break

        case 'AguardandoNegociacaoParticular':
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'aguardandoNegociacaoParticular', value: true })
          this.ga('backoffice-autorizacao', 'aguardando-negociacao-particular')
          break

        default:
          EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
          this.getBackofficeGlobalStore.setBackofficeArea(backofficeRoute())

          this.getBackofficeGlobalStore.setSolicitacaoId(agendamentoCirurgia.id)
          this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })
          break
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
  }

  async showModalAutorizacao(agendamentoCirurgia: AgendamentoCirurgia) {
    this.ga('backoffice-autorizacao', 'abrir-modal-autorizacao')
  }

  async resolverContestacao(agendamento: AgendamentoCirurgia) {
    this.loadingResolverContestacao = agendamento.id
    this.getBackofficeGlobalStore.setSolicitacaoId(agendamento.id)
    this.getBackofficeGlobalStore.setHospitalId(agendamento.hospitalId)
    const request = await this.getBackofficeGlobalStore.getContestacaoMedica(agendamento.id)
    if (request.success) {
      this.getBackofficeGlobalStore.setModal({ name: 'contestacaoMedica', value: true })
    }
    this.loadingResolverContestacao = ''
  }

  /** Pendência */
  async showModalRespondePendencia(agendamentoCirurgia: AgendamentoCirurgia) {
    const solicitacaoId = agendamentoCirurgia.id
    const { hospitalId } = agendamentoCirurgia
    this.loadingRespondePendencia = solicitacaoId
    let response = await this.autorizacao.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getPendenciaStore.getPendencias(solicitacaoId)
      if (response.success) {
        this.getDisplayPendencia = {
          nomePaciente: agendamentoCirurgia.pacienteNome,
          nomeMedico: agendamentoCirurgia.medicoNome,
        }
        this.showModalPendencia = true
        this.getBackofficeGlobalStore.setSolicitacaoId(solicitacaoId)
        this.getBackofficeGlobalStore.setHospitalId(hospitalId)
      } else {
        this.getBackofficeAutorizacaoStore.deleteSolicitacao(solicitacaoId)
        await this.openFlowModal(agendamentoCirurgia)
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'done', color: '#2E7D32' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingRespondePendencia = ''
    this.ga('backoffice-autorizacao', 'responder-pendencia-autorizacao')
  }


  async encerrarPendencia() {
    this.loadingEncerrarPendencia = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const response = await this.pendenciaSolicitacao.encerrarPendencia(solicitacaoId)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
      this.getBackofficeAutorizacaoStore.deleteSolicitacao(solicitacaoId)
      await this.openFlowModal(this.getBackofficeGlobalStore.solicitacao)
      await this.closeModalPendencia()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao encerrar a pendência.', icon: 'warning', color: '#C62828' })
    }
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    await this.getPendenciaStore.enviarMensagem(pendenciaMensagem)
    this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  async inputFileAutorizacao(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    let response = await this.getPendenciaStore.uploadDocumento(param)
    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      response = await this.getPendenciaStore.enviarMensagem(pendenciaMensagem)
      if (response.success) {
        this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      }
    }

    this.loadingUpload = false
  }

  async confirmarEncerrarPendencia() {
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    this.loadingConfirmarEncerrarPendencia = true
    const response = await this.pendenciaSolicitacao.encerrarPendencia(solicitacaoId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
      await this.openFlowModal(this.getBackofficeGlobalStore.solicitacao)
      this.getBackofficeAutorizacaoStore.deleteSolicitacao(solicitacaoId)
      this.closeModalPendencia()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao encerrar a pendência.', icon: 'warning', color: '#C62828' })
    }

    this.loadingConfirmarEncerrarPendencia = false
  }

  async confirmarEncerrarPendenciaCloseModal() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalConfirmarEncerrarPendencia = true
    this.loadingClosePendencia = false
  }

  async closeEncerrarPendenciaCloseModal() {
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    this.loadingCloseConfirmarEncerrarPendencia = true
    await this.autorizacao.desbloquearSolicitacao(solicitacaoId)
    this.closeModalPendencia()
  }

  async closeModalPendencia() {
    await timeoutDefault()
    this.showModalPendencia = false
    this.showModalConfirmarEncerrarPendencia = false

    this.loadingCloseConfirmarEncerrarPendencia = false
    this.loadingEncerrarPendencia = false
    this.getDisplayPendencia = {
      nomePaciente: '',
      nomeMedico: '',
    }
    this.getPendenciaStore.clearPendencia()
  }

  loadAllSolicitacoes: boolean = false

  get loadingAllSolicitacoes() { return this.loadAllSolicitacoes }
  set loadingAllSolicitacoes(value: boolean) { this.loadAllSolicitacoes = value }

  get backofficeRegulacaoStore() {
    return getModule(BackofficeRegulacaoStore, this.$store)
  }

  async getAllBackofficeSolicitacoes() {
    this.loadingAllSolicitacoes = true
    const response = await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch()
    if (!response.success) EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
    this.loadingAllSolicitacoes = false
  }

  saveHeaders(area: string = '') {
    (localStorage as any).setItem(`backoffice-${area.toLowerCase()}-table-headers`, JSON.stringify(this.headers, null, 2))
  }

  beforeDestroy() {
    this.getBackofficeAutorizacaoStore.clearFiltro()
    this.getBackofficeAutorizacaoStore.setFilterOn(false)
    this.getBackofficeAutorizacaoStore.setTodosOsStatus(false)
    this.getBackofficeAutorizacaoStore.setTodosOsStatusDaArea(false)
    this.getBackofficeAutorizacaoStore.resetSituacoes()
    this.getBackofficeGlobalStore.setBackofficeArea('')
  }

  created() {
    window.addEventListener('keydown', this.keyboardShortCuts)
  }

  destroyed() {
    window.removeEventListener('keydown', this.keyboardShortCuts)
  }

  keyboardShortCuts(event: KeyboardEvent) {
    if (event.ctrlKey && event.code === 'Space' && !!this.showAdvancedFilters) this.showAdvancedFilters()
    if (event.ctrlKey && event.altKey && event.code === 'Space' && !!this.clearAdvancedFilters) this.clearAdvancedFilters()
  }
}
